import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { field, countryIs, REQUIRED } from "./utils";
import * as CROATIA from "../../onboarding/profile-info/form/hr/constants.hr";

export const croatiaFields = {
  hrJmbg: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "hrJmbg",
    label: "JMBG (Unique Citizen Number)",
    validations: {
      ...REQUIRED,
      text: {
        length: {
          value: 13,
          message: "Must contain exactly 13 digits",
        },
        matches: {
          value: CROATIA.hrJmbgRegEx,
          message:
            "Must contain exactly 13 digits (no spaces or special characters)",
        },
      },
    },
    scenarios: {
      onboarding: countryIs("HR"),
    },
    value: () => "",
  }),
  hrOib: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "hrOib",
    label: "OIB (Personal Identification Number)",
    validations: {
      ...REQUIRED,
      text: {
        length: {
          value: 11,
          message: "Must contain exactly 11 digits",
        },
        matches: {
          value: CROATIA.hrOibRegEx,
          message:
            "Must contain exactly 11 digits (no spaces or special characters)",
        },
      },
    },
    scenarios: {
      onboarding: countryIs("HR"),
    },
    value: () => "",
  }),
  hrEducationLevel: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "hrEducationLevel",
    label: "Školska sprema (Education Level)",
    placeholder: "Select Education Level",
    options: CROATIA.EDUCATION_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("HR"),
    },
    value: () => "",
  }),
  hrPensionInsuranceNumber: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "hrPensionInsuranceNumber",
    label: "Osobni broj (Pension Insurance Number)",
    validations: {
      ...REQUIRED,
      text: {
        max: {
          value: 10,
          message: "Must be up to 10 characters",
        },
        matches: {
          value: CROATIA.hrOsobniBrojRegEx,
          message: "Must contain only digits and uppercase letters",
        },
      },
    },
    scenarios: {
      onboarding: countryIs("HR"),
    },
    value: () => "",
  }),
  hrDrugiSetup: field({
    type: FieldTypes.boolean,
    informationType: "identification",
    name: "hrDrugiSetup",
    label: "Drugi Setup",
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("HR"),
    },
    value: () => false,
    format: (value) => (value.toString() === "true" ? "Yes" : "No"),
  }),
};
